<template>
  <div
    v-if="showEnvironmentBanner"
    class="environment-banner"
  >
    <h1>IFE Data {{ toTitleCase(environment) }} Environment</h1>
  </div>
</template>

<script>
import Strings from '@/Client/Mixin/Strings';

export default {
  name: 'EnvironmentBanner',
  mixins: [
    Strings,
  ],
  computed: {
    showEnvironmentBanner() {
      return 'PRODUCTION' !== this.environment;
    },
    environment() {
      return process.env.ENVIRONMENT_NAME?.toUpperCase() ?? 'PRODUCTION';
    },
  },
};
</script>

<style scoped>
.environment-banner {
  width: 100%;
  background-color: red;
  color: white;
  text-align: center;

  h1 {
    margin-bottom: 0;
  }
}
</style>
